// ** React Imports
import { lazy } from 'react';

const MarketingPopupRoutes = [
  {
    path: 'marketing/popups',
    component: lazy(() => import('views/marketing/popups')),
  },
  {
    path: 'marketing/popups/add',
    component: lazy(() => import('views/marketing/popups/popup-add')),
  },
  {
    path: 'marketing/popups/:id',
    component: lazy(() => import('views/marketing/popups/popup-edit')),
  },
];

export default MarketingPopupRoutes;
